import React, { useState, useEffect } from 'react'
import styles from '../CustomDomainModal.module.css'
import { OptionButton } from './SharedComponents'
import CTAButton from 'components/CTAButton/CTAButton'
import { DNS_SETTINGS } from '../constants/strings'
import { Button, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { isMobileMode } from '../../ProPlans/PricingModalContent'
import { fetchNameServers } from '../../../services/custom-domain'
import { detectRegistrar } from '../../../utils/registrarMatcher'

const DNSSetting = ({
  formik,
  onNext,
  onPrevious,
  handleCheckEntri,
  setActiveStep,
  showPayWall,
  publishToCustomDomain,
  onFail
}) => {
  const [loading, setLoading] = useState(false)
  const [registrarInfo, setRegistrarInfo] = useState(null)
  const { values } = formik
  const isOwner = !!(values.dnsAddress.selected === 'yes')
  const isRootDomain = !!!values.dnsAddress.subdomain
  const domain_value = values.dnsAddress.domain
  const subdomain = values.dnsAddress.subdomain
  const fulldomainAddress = !!subdomain ? `${subdomain}.${domain_value}` : domain_value

  const history = useHistory()

  useEffect(() => {
    if (domain_value) {
      fetchNameServers(domain_value).then((nameServers) => {
        const info = detectRegistrar(nameServers)
        if (info) {
          setRegistrarInfo(info)
        }
      })
    }
  }, [domain_value])

  const handleNext = async () => {
    let registrarName = registrarInfo?.registrarName

    if (values.dnsAddress.selected === 'yes') {
      setLoading(true)

      const paywallTriggered = showPayWall() // Check if paywall was shown

      if (paywallTriggered) {
        setLoading(false) // Reset loading state if paywall was shown
        return // Stop execution here
      }

      if (!registrarName && domain_value) {
        try {
          const nameServers = await fetchNameServers(domain_value)
          const info = detectRegistrar(nameServers)
          if (info?.registrarName) {
            registrarName = info.registrarName
          }
        } catch (e) {
          console.error('Failed to resolve registrarName on handleNext', e)
        }
      }

      const payload = {
        domain: fulldomainAddress,
        owner: isOwner,
        replaceWWW: isRootDomain,
        publishToCustomDomain,
        registrar: registrarName
      }

      const response = await handleCheckEntri(payload, formik)

      if (response === 'manual') {
        formik.setFieldValue(`wizard.selected`, 'no')
        setActiveStep(3)
      } else if (response === 'configured') {
        setActiveStep(4)
      } else if (response === 'automatic') {
        formik.setFieldValue(`wizard.selected`, 'yes')
        setLoading(false)
        onNext()
      } else {
        setLoading(false)
      }
    } else if (values.dnsAddress.selected === 'no') {
      setLoading(false)
      const isServerFile = localStorage.getItem('isServerFileForCustomDomain') === 'true'

      if (isServerFile) {
        onFail?.({
          show: true,
          error: true,
          title: 'DNS Access Required',
          message: 'Sorry, you need access to DNS settings for PHP files.'
        }) || alert('Sorry, you need access to DNS settings for PHP files.')
        return
      }

      if (isMobileMode()) {
        alert('You need to own the domain to connect it to your site.')
      } else {
        onNext()
      }
    }
  }

  const handlePrevious = async () => {
    history.push({ pathname: '/manage/custom-domain/add' })
    onPrevious()
  }

  return (
    <div className={styles.container}>
      <div className={styles.subHeading}>
        <div className={styles.title}>{DNS_SETTINGS.SUBHEADING}</div>
        <div className={styles.subTitle}>{DNS_SETTINGS.DESCRIPTION}</div>
      </div>

      <div className={styles.optionCon}>
        <OptionButton
          actionDesc={'I already own the domain'}
          actionlabel={'Yes'}
          active={values.dnsAddress.selected === 'yes'}
          selectOption={() =>
            formik.setFieldValue(`dnsAddress.selected`, values.dnsAddress.selected === 'yes' ? null : 'yes')
          }
        />
        <OptionButton
          actionDesc={'I need to buy the domain.'}
          actionlabel={'No'}
          selectOption={() =>
            formik.setFieldValue(`dnsAddress.selected`, values.dnsAddress.selected === 'no' ? null : 'no')
          }
          active={values.dnsAddress.selected === 'no'}
        />
      </div>
      <div className={styles.btnContainer}>
        <Button
          variant="outline-primary"
          onClick={handlePrevious}
          size="small"
          showLeftArrow={true}
          showArrow={false}
          leftArrowClass={styles.backArrow}
        >
          Back
        </Button>
        <Button
          onClick={handleNext}
          size="small"
          disabled={loading || !values.dnsAddress.selected}
          className={styles.forwardButton}
          loading={loading}
        >
          Next {loading && <Spinner animation="border" variant="light" size="sm" />}
        </Button>
      </div>
    </div>
  )
}

export default DNSSetting
